import { ReactNode } from "react";
import { TableProps } from "..";

import Card from "components/Card";
import Tab from "components/Layout/Navbar/Tab";
import TableScrollable from "../TableScrollable";

import { isObjectEmpty } from "helpers/isObjectEmpty";
import cn from "lib/cn";

import { TTabItem } from "components/Layout/Navbar/Tab/types";

export interface TableBoxProps extends TableProps {
  title?: React.ReactNode;
  containerClassName?: string;
  tabs?: TTabItem;
  action?: React.ReactNode;
  selectedTab?: string;
  mainAction?: React.ReactNode;
  topLeftIcon?: ReactNode;
  onRowClick?: (id: string) => void;
  onChangeTab?: (key: string) => void;
}

const TableCard = ({
  title,
  containerClassName,
  tabs = {},
  action,
  selectedTab,
  mainAction,
  topLeftIcon,
  onChangeTab,
  ...props
}: TableBoxProps) => {
  return (
    <Card containerClassName="px-0">
      <div className="flex justify-between px-6 pt-2 pb-5 gap-2">
        <div className="flex gap-x-2.5 items-center">
          {topLeftIcon}
          <div className="text-2xl font-semibold text-night">{title}</div>
        </div>
        {mainAction ? (
          mainAction
        ) : (
          <div className="flex justify-end gap-3 items-center">
            <div>
              <Tab
                buttonClassName="font-normal h-[2.5rem]"
                items={tabs}
                selected={selectedTab}
                onChange={onChangeTab}
              />
            </div>
            {action && (
              <div className="h-full flex items-center gap-3">
                {!isObjectEmpty(tabs) && (
                  <div className="h-full w-[0.15rem] bg-line-500" />
                )}
                {action}
              </div>
            )}
          </div>
        )}
      </div>

      <TableScrollable
        containerClassName={cn("rounded-b-xl", containerClassName)}
        {...props}
      />
    </Card>
  );
};

export default TableCard;
